module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-404 no-margin",
    staticStyle: {
      "margin-top": "10vh !important",
      "margin-right": "50px !important"
    }
  }, [_c('h1', {
    staticClass: "no-margin",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('errors.ups')))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "no-margin",
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('errors.pageNotFound')))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "30vh"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": require("../../assets/notfound.svg")
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4076649a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4076649a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/PageNotFound.vue
// module id = 1398
// module chunks = 1